// This hook is used to determine if the new member MHP view should be shown for the user.
// It also includes flag and method to force showing new member MHP view from outside (e.g., Dynamic Yield).
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import globalDyHandler from 'core/utils/helpers/dyHandler';
import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';

export const useShouldShowNewMembersView = () => {
  const isMobileMQ = useSelector(selectIsMobileMQ);
  const hasFCookieTrue = Cookies.get('f') === 'true';
  const [shouldForceShowNewMembersView, setShouldForceShowNewMembersView]
    = useState(globalDyHandler.shouldForceShowNewMembersView || false);

  useEffect(() => {
    // Global method, which could be triggered from outside
    globalDyHandler.showNewMembersView = () => {
      setShouldForceShowNewMembersView(true);
    };
  }, []);

  if (!isMobileMQ) {
    return false;
  }

  return hasFCookieTrue || shouldForceShowNewMembersView;
};
